import { IonFab, IonFabButton, IonIcon } from "@ionic/react";
import { add } from "ionicons/icons";

export const ProfilesAddButton = () => {
  return (
    <IonFab vertical="bottom" horizontal="end" slot="fixed">
      <IonFabButton routerLink={`/app/tic/perfiles/crear`}>
        <IonIcon icon={add} />
      </IonFabButton>
    </IonFab>
  );
};
